<template>

  <v-card>
    <!-- barra superior -->
    <v-card-title class="buttonBar" style="background-color: #43A047; color: #fff; padding: 15px;">
      <div style='width:100% '>
        <div style="float: left;">
          <span class="headline">{{ $t('buscadorProductos') }}</span>
        </div>
        <!-- cerrar -->
        <div style="float: right; margin-top: -8px; margin-right: -10px">
          <v-btn flat icon color="white" @click="fCerrarVentana(); fLimpiar()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <!-- elemenos seleccionados -->
        <div style="float: right; margin-top : 4px;">
          <!-- lista de elemenos seleccionados -->
          <div class="text-xs-center" style="display: inline-block; margin-top : -7px">
            <v-menu offset-x :close-on-content-click="false" :nudge-width="100" max-height="500" v-model="dMenu" bottom
              right>

              <div slot="activator"
                style="display: inline-block;max-height: 35px; margin-top:-5px;margin-right:10px; width: auto ; border-radius: 0%; padding: 4px;background-color: #3d8c41;color:white">
                <span class="white--text body-2">{{ dNumArticulos }}</span>
                <v-icon style="color:white">mdi-chevron-down</v-icon>
              </div>

              <v-card>

                <v-toolbar flat style="background-color: #3d8c41">
                  <v-toolbar-title style="margin-top:5px;margin-bottom:5px;color:white;font-weight:400"
                    class="subheading">{{ $t('elementosSeleccionados') }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-divider></v-divider>
                <v-list style="padding: 0px;" two-line>
                  <template v-if="dItemsArticulos.length > 0">
                    <v-list-tile @click.stop v-for="(item, i) in dItemsArticulos" :key="i"
                      style="margin-left:0px;border-bottom: 1px solid rgba(0,0,0,0.12)">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.articulo" class="body-1"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.nombreArticulo" class="caption"></v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action v-html="fFormatCantidad(item.cantidad)"></v-list-tile-action>
                    </v-list-tile>
                  </template>
                  <v-list-tile v-if="dItemsArticulos.length === 0" style="margin-bottom:10px;margin-left:5px">
                    <v-list-tile-content>
                      <v-list-tile-title class="body-1">{{ $t('noElementosSeleccionados') }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>

              </v-card>
            </v-menu>
          </div>

          <span class="subheading">{{ $t('elementosSeleccionados') }}</span>&nbsp;&nbsp;&nbsp;
        </div>
      </div>
    </v-card-title>
    <!-- lista de articulos -->
    <v-card-text style="padding-top: 4px;padding-bottom: 4px;">
      <v-container fluid class="buttonBarSearch" style="padding:0px">
        <v-layout row wrap>
          <v-flex xs12 sm3>
          </v-flex>
          <v-flex xs12 sm9>
            <div style="margin-right:15px">
              <v-text-field color="green darken-1" :name="$t('busquedaArticulos')" :label="$t('busquedaArticulos')"
                single-line append-icon="search" v-on:keyup.enter="fSearchArticulo"
                v-model="dSearchArticulo"></v-text-field>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid style="padding:0px">
        <v-layout>
          <v-flex xs12>

            <v-list three-line>
              <v-list-tile v-for="(item, index) in dItems" v-bind:key="index" @click.stop
                style="border-bottom: 1px solid rgba(0,0,0,0.12) ">
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.nombreArticulo"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.articulo"></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-container fluid>
                    <v-layout row nowrap class="text-sm-right">
                      <NumberTextFieldSpinner :id="item.articulo" :min="0" :max="100000" :integerOnly="false"
                        v-model="item.cantidad" />
                      <v-btn
                        :color="item.cantidad === 0 || item.cantidad === '' ? 'grey lighten-1' : 'green lighten-1 white--text'"
                        :disabled="item.cantidad === 0 || item.cantidad === ''" value="add" @click="fAddProdList(item)"
                        style="min-width:30px;margin-top:4px;margin-left:20px">
                        <span>add</span>
                      </v-btn>
                    </v-layout>
                  </v-container>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>

          </v-flex>
        </v-layout>
        <!-- paginacion -->
        <div class="text-xs-right">
          <div style="float: right;top:15px">
            <span class="body-1" style="color:#999999">{{ dStartOffset }}-{{ dEndOffset }} of {{ dTotalRows }}</span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <v-btn flat @click.prevent="fPrevPagina()" color="grey darken-1" icon :disabled="dStartOffset === 1">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn flat @click.prevent="fNextPagina()" color="grey darken-1" icon :disabled="dTotalRows === dEndOffset">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            &nbsp;&nbsp;&nbsp;
          </div>
        </div>
      </v-container>

    </v-card-text>
    <!-- botonera principal -->
    <v-card-actions style="background-color: #eee;padding: 15px">
      <v-spacer></v-spacer>
      <v-btn color="grey darken-1  white--text" @click="fLimpiar()">
        <span>{{ $t('limpiar') }}</span>
      </v-btn>
      <v-btn color="grey darken-1  white--text" @click="fCerrarVentana(); fLimpiar()">
        <span>{{ $t('cancelar') }}</span>
      </v-btn>
      <v-btn color="green darken-1  white--text" @click="fAddProdPres(); fLimpiar();">
        <v-icon>mdi-keyboard-return</v-icon>
        <span>{{ $t('aplicar') }}</span>
      </v-btn>
    </v-card-actions>
    <div style="flex: 1 1 auto;"></div>
  </v-card>
</template>

<script>
import NumberTextFieldSpinner from '@/components_datadec/NumberTextFieldSpinner'

// SERVICES
import SrvPres from '@/services/srv-presupuestos'
import SrvGeneral from '@/services/srv-general'

export default {
  name: 'ShpBuscador',
  data() {
    return {
      dItems: [],
      dItemsArticulos: [],
      dLoadingArticulo: false,
      dNumArticulos: '0',
      dEmpresa: null,
      dCliente: null,
      dSucursal: null,
      dSearchArticulo: '',
      dPage: 1,
      dTotal: 1,
      dTotalRows: 1,
      dStartOffset: 1,
      dEndOffset: 1,
      dMenu: false,
      dTimerSearch: null,
      eventoMostrar: 'evento-mostrarAvisos'

    }
  },
  components: {
    NumberTextFieldSpinner
  },
  watch: {
    /**
     * Si cambia el campo de busqueda de articulos lanza nueva busqueda
     */
    // dSearchArticulo: {
    //   handler () {
    //     // console.log('watch-search ' + this.search)
    //     clearInterval(this.dTimerSearch)
    //     this.dTimerSearch = setTimeout(function () {
    //       this.dPage = 1
    //       this.dTotal = 1
    //       this.dTotalRows = 1
    //       this.dStartOffset = 1
    //       this.dEndOffset = 1
    //       this.fCargaArticulos()
    //     }.bind(this), 1500)
    //   }
    // }
  },
  methods: {
    fSearchArticulo() {
      this.dPage = 1
      this.dTotal = 1
      this.dTotalRows = 1
      this.dStartOffset = 1
      this.dEndOffset = 1
      this.fCargaArticulos()
    },
    fEventCargarArticulos(empresa, cliente, sucursal) {
      this.dEmpresa = empresa
      this.dCliente = cliente
      this.dSucursal = sucursal
      this.fCargaArticulos()
    },
    /**
     * Metodo para limpiar la lista de articulos seleccionados
     */
    fLimpiar() {
      this.dNumArticulos = 0
      this.dItemsArticulos = []
      for (var i = 0; i < this.dItems.length; i++) {
        const item = this.dItems[i]
        item.cantidad = 0
      }
    },
    /**
     * Metodo para cerrar la ventana
     */
    fCerrarVentana() {
      this.$emit('close')
    },
    /**
     * Metodo para incluir nuevos productos en las lineas de pedido
     */
    fAddProdPres() {
      this.$emit('add', this.dItemsArticulos)
    },
    /**
     * Metodo para añadir cantidades de producto a la lista
     */
    fAddProdList(item) {
      if (item.cantidad && item.cantidad > 0) {
        const itemCopy = JSON.parse(JSON.stringify(item))
        this.$bus.$emit(this.eventoMostrar, '<p>Añadido/s  <b>' + itemCopy.cantidad + '</b> artículos del producto: </p> <br> <p>' + itemCopy.nombreArticulo + '</p> ')

        this.dItemsArticulos.push(itemCopy)
        const temp = parseFloat(this.dNumArticulos.toString().replace(',', '.')) + parseFloat(item.cantidad.toFixed(2))
        let tempString = '' + temp
        tempString = tempString.replace('.', ',')
        tempString = tempString.replace(',00', '')
        this.dNumArticulos = tempString
        this.dLoadingArticulo = false
        item.cantidad = 0
      }
    },
    /**
     * Carga los articulos
     */
    fCargaArticulos() {
      const rowsPerPage = 5
      this.$emit('loading', this.$t('iniCabArticulos'))
      const offset = 5 * (this.dPage - 1) + 1
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        cliente: this.dCliente,
        sucursal: this.dSucursal,
        offset: offset,
        numRows: rowsPerPage,
        search: this.dSearchArticulo
      }

      SrvGeneral.lovArt(payload).then(response => {
        if (response.data.statusCode === '200') {
          this.dItems = []
          const dataArticulos = response.data
          this.dItems = dataArticulos.ARTICULOS.map((item) => {
            return {
              articulo: item.artArticulo,
              cantidad: 0,
              cliente: item.cliente,
              dto: 0,
              dto1: 0,
              dto2: 0,
              dto3: 0,
              tipoDescuentoLinea: 0,
              dtoEntre12: '+',
              dtoEntre23: '-',
              empresa: item.artEmpresa,
              imagen: item.artImagen,
              importe: item.artPrecioLimite,
              nombreArticulo: item.artDescripcion,
              nombreLargoArticulo: item.artDescripcion,
              numeroItem: item.id,
              numeroPedido: item.numeroPedido,
              observaciones: item.observaciones,
              precioArticulo: item.artPrecioLimite,
              sort: item.sort,
              unidadMedVentas: item.artUnidadMedVentas
            }
          })
          if (dataArticulos.totalRows / rowsPerPage > 0) {
            this.dTotal = (!Number.isInteger(dataArticulos.totalRows / rowsPerPage)) ? Math.trunc(dataArticulos.totalRows / rowsPerPage) + 1 : Math.trunc(dataArticulos.totalRows / rowsPerPage)
          } else {
            this.dTotal = 1
          }
          this.dTotalRows = dataArticulos.totalRows
          this.dStartOffset = offset

          this.dEndOffset = (offset + 5 - 1 < this.dTotalRows) ? offset + 5 - 1 : this.dTotalRows
          // GET IMAGES
          let directorio = ''
          const files = this.dItems.map((item) => {
            const img = item.imagen.split('/')[item.imagen.split('/').length - 1]
            directorio = item.imagen.replace(img, '').toLowerCase()
            return {
              name: img
            }
          })
          const payload = {
            items: files,
            directory: directorio,
            publicSN: 'N',
            contentType: 'BASE64'
          }
          SrvPres.cargarImagenes(payload).then(response => {
            if (response.data.statusCode === 200) {
              this.dItems.map((item, index) => {
                if ((response.data.items[index].statusCode === undefined || response.data.items[index].statusCode === null)) {
                  item.imagen = response.data.items[index].url + '&t=' + this.$store.getters.getAutenticacion.tira
                } else {
                  item.imagen = 'https://astepahead.nl/getimage/products/jltfnt2-40.jpg;jltfnt2-40-front.jpg'
                }
              })
            } else {
              this.$emit('alert', '<b>carga las imagenes</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
            }
          }).catch(error => {
            this.fErrorComprobado(error)
          })
        } else {
          this.$emit('alert', '<b>obtiene los articulos</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
        this.$emit('loading', '')
      }).catch(error => {
        this.fErrorComprobado(error)
        this.$emit('loading', '')
      })
    },
    /**
     * Vuelve a tras la paginacion
     */
    fPrevPagina() {
      if (this.dStartOffset !== 1) {
        this.dPage = this.dPage - 1
        this.fCargaArticulos()
      }
    },
    /**
     * avanza la paginacion
     */
    fNextPagina() {
      if (this.dTotalRows !== this.dEndOffset) {
        this.dPage = this.dPage + 1
        this.fCargaArticulos()
      }
    },
    /**
     * formatea la cantidad
     */
    fFormatCantidad(cantidad) {
      let tempString = '' + cantidad
      tempString = tempString.replace('.', ',')
      tempString = tempString.replace(',00', '')
      return tempString
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.buttonBar .card__title {
  padding: 8px !important;
}

.buttonBarSearch .card__title {
  padding: 0px !important;
}

.buttonBarSearchTop .card__text {
  padding-top: 4px !important;
  padding-bottom: -10px !important;
}

.numberInputSpinnerInput .vnis__input {
  background: #ffffff !important;
  border: 0px !important;
  border-bottom: 1px solid #999999 !important;
}

.numberInputSpinnerButton .vnis__button {
  background: #ffffff !important;
  color: #000000 !important;
}

.avatarArticulos .avatar {
  width: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Informes/Presupuestos/ShpBuscador.vue